import React from 'react';

import { messages } from '../../messages';
import {
	AiInteractionFeedbackModal,
	type AiInteractionFeedbackModalProps,
} from '../../services/ai-interaction-feedback-modal';

export type HarmfulContentModalProps = Omit<
	AiInteractionFeedbackModalProps,
	'includeFeedbackCheckboxLabel' | 'feedbackTitle'
>;

/**
 * Feedback Collector modal for reporting harmful AI content
 */
export const HarmfulContentModal = (props: HarmfulContentModalProps): React.JSX.Element => {
	return (
		<AiInteractionFeedbackModal
			{...props}
			includeFeedbackCheckboxLabel={messages.consentCheckboxLabel}
			feedbackTitle={messages.harmfulContentFeedbackTitle}
		/>
	);
};
